import { Box, Paper, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'
import { FileError, FileWithPath } from 'react-dropzone'

import { getDropzoneData, getErrorList } from '../../FileUploader.utils'

type Props = {
	fileRejections: readonly { file: FileWithPath; errors: readonly FileError[] }[]
}

export default function RejectedFiles({ fileRejections }: Props) {
	return (
		<Paper
			variant="outlined"
			sx={{
				py: 1,
				px: 2,
				mt: 3,
				borderColor: 'error.light',
				bgcolor: (theme) => alpha(theme.palette.error.main, 0.08),
			}}
		>
			{fileRejections.map((fileRejection, index) => {
				const { file } = fileRejection
				const { path, size } = getDropzoneData(file, index)
				return (
					<Box key={path} sx={{ my: 1 }}>
						<Typography variant="subtitle2" noWrap>
							{path} - {size || ''}
						</Typography>
						{getErrorList(fileRejection)}
					</Box>
				)
			})}
		</Paper>
	)
}
